import React from "react";
import DefaultLink from '../../../components/DefaultLink'

export default function HumanSmart({ smartData , showHeading=true}) {

  return (
    <>
      {smartData?.boxes && smartData?.boxes?.map((data, index) => (
        <section key={index} className="human-smart-area">
          <div className="container">
            <div className="row justify-content-center">
              {index === 0 &&  showHeading ?
                <div className="col-lg-9">
                  <div className="human-smart-headbox">
                    <h3 className="heading center-heading">{smartData?.head}</h3>
                    <p className="sub-heading">{smartData?.desc}</p>
                  </div>
                </div>
                :
                null}
            </div>
            <div className="row justify-content-between align-items-center">
              <div className={`col-lg-6 col-md-6 wow animate__animated animate__zoomIn ${index % 2 === 1 ? null : 'order-md-1'}`} data-wow-duration="0.6s" data-wow-delay="0s">
                <div className={`human-smart-image ${index % 2 === 0 ? null : 'human-smart-leftimage'}`}>
                  <img src={data?.image} alt="Smart Human Image" />
                </div>
              </div>
              <div className={`col-lg-5 col-md-6 ${index % 2 === 1 ? null : 'order-md-0'}`}>
                <div className="human-smart-content">
                  <small>{data?.label}</small>
                  <h3 className="heading">{data?.innerHead}</h3>
                  <p>{data?.innerDesc}</p>
                  <DefaultLink text={data?.btn} to={data?.slug} />
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}
    </>
  )
}